import { createFileRoute } from '@tanstack/react-router';
import { MyInvitationsView } from '@/components/membership-requests';

// The "Invitations" page — the durable, query-backed consent surface (D6).
// Lists the viewer's pending inbound invites to Circles and Networks; they
// Accept (→ membership) or Decline here. The `circle.invited`/`network.invited`
// notifications deep-link to this route.
export const Route = createFileRoute('/_authed/invitations/')({
  component: InvitationsPage,
});

function InvitationsPage() {
  return <MyInvitationsView />;
}
